/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineVerifyBookingRsDto } from './traveline-verify-booking-rs-dto';
import {
    TravelineVerifyBookingRsDtoFromJSON,
    TravelineVerifyBookingRsDtoFromJSONTyped,
    TravelineVerifyBookingRsDtoToJSON,
    TravelineVerifyBookingRsDtoToJSONTyped,
} from './traveline-verify-booking-rs-dto';

/**
 * <p>
 *             Response to booking possibility check<br />
 *             If a reservation with conditions from ‘search’ is possible:
 *             </p>
 * <ul>
 *   <li>in the ‘booking’ field possible booking</li>
 *   <li>alternativeBooking - null</li>
 * </ul>
 * <p>
 *             If conditions have changed and bookings with the conditions from the ‘search’ are no longer available (price, cancellation policy, services included in the rate plan)
 *             </p>
 * <ul>
 *   <li>booking - null</li>
 *   <li>in the alternativeBooking field, booking under the new conditions</li>
 *   <li>is filled with Warning</li>
 * </ul>
 * @export
 * @interface TravelineVerifyBookingResultDto
 */
export interface TravelineVerifyBookingResultDto {
    /**
     * 
     * @type {TravelineVerifyBookingRsDto}
     * @memberof TravelineVerifyBookingResultDto
     */
    booking?: TravelineVerifyBookingRsDto;
}

/**
 * Check if a given object implements the TravelineVerifyBookingResultDto interface.
 */
export function instanceOfTravelineVerifyBookingResultDto(value: object): value is TravelineVerifyBookingResultDto {
    return true;
}

export function TravelineVerifyBookingResultDtoFromJSON(json: any): TravelineVerifyBookingResultDto {
    return TravelineVerifyBookingResultDtoFromJSONTyped(json, false);
}

export function TravelineVerifyBookingResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineVerifyBookingResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'booking': json['booking'] == null ? undefined : TravelineVerifyBookingRsDtoFromJSON(json['booking']),
    };
}

  export function TravelineVerifyBookingResultDtoToJSON(json: any): TravelineVerifyBookingResultDto {
      return TravelineVerifyBookingResultDtoToJSONTyped(json, false);
  }

  export function TravelineVerifyBookingResultDtoToJSONTyped(value?: TravelineVerifyBookingResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking': TravelineVerifyBookingRsDtoToJSON(value['booking']),
    };
}

